const imagesCarousel = {
  backgroundColor: ({ theme }) => theme.colors.kullgront,
}

export default imagesCarousel
